import useEvents from "@/hooks/useEvents"

const EventSelect = ({
  hideEventId,
  value,
  onChange,
}: {
  hideEventId?: string
  value?: string
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}) => {
  const { events, isLoading } = useEvents()
  const filteredEvents = events.filter((event) => event.id !== hideEventId)

  return (
    <div>
      <label
        htmlFor="event"
        className="block text-sm leading-6 font-medium text-gray-900"
      >
        Select new event
      </label>
      <div className="relative">
        <select
          value={value}
          onChange={onChange}
          disabled={isLoading}
          id="event"
          className="focus:ring-chessdrop-600 mt-1 block w-full rounded-lg border-0 py-2 text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
        >
          <option value="" />
          {filteredEvents.map((event) => (
            <option key={event.id} value={event.id}>
              {event.name}
            </option>
          ))}
        </select>
        {isLoading && (
          <div className="absolute top-1/2 right-10 -translate-y-1/2 transform">
            <div
              className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-gray-400"
              style={{ borderRightColor: "transparent" }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default EventSelect
